import ChatMessage from "../ChatMessage/ChatMessage.jsx";
import "./ChatLog.css";

const ChatLog = ({ chatLog, isLoading }) => {
  return (
    <div className="chat-log">
      {chatLog.map((message, index) => (
        <ChatMessage key={index} message={message} />
      ))}
      {isLoading && (
        <div className="chat-message ai">
          <div className="chat-message-center">
            <div className="message">...</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ChatLog;
